export const TOGGLE_SPOTLIGHT_SEARCH = 'syftacp/TOGGLE_SPOTLIGHT_SEARCH'
export const TOGGLE_WORKER_SPOTLIGHT_SEARCH = 'syftacp/TOGGLE_WORKER_SPOTLIGHT_SEARCH'
export const TOGGLE_EMPLOYER_SPOTLIGHT_SEARCH = 'syftacp/TOGGLE_EMPLOYER_SPOTLIGHT_SEARCH'
